import { useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap'

import DatePickerComponent from '../../../../../../componentsV2/DataEntryComponents/DatePicker/DatePicker'
import InputNumberComponent from '../../../../../../componentsV2/DataEntryComponents/InputNumber/InputNumber'
import MinusIconComp from './MinusIconComp'
import SelectComponent from '../../../../../../componentsV2/DataEntryComponents/MultipleSelect/MultipleSelect'

import { submitCollection } from '../../../../../../_services/submit.service'
import useFetchMultipleAPIs from '../../../../../../hooks/useFetchMultipleAPIs'

const FormColumnTwo = ({
    adavnceFilterFormVal,
    defSaveObj,
    dmode,
    dir,
    t,
    setAdavnceFilterFormVal,
    depId,
}) => {
    const apiUrls = useMemo(() => [
        {
            url: submitCollection.getAllPlanogramEdition,
            filter: depId ? `?departmentId=${depId}` : '',
        },
    ], [depId])

    const { data, isLoading, error } = useFetchMultipleAPIs(apiUrls)

    const [multipleSelectOptions, setMultipleSelectOptions] = useState({
        edition: [],
    })

    useMemo(() => {
        if (data.length > 0 && data[0]) {
            let editionsArray = data[0]?.extra || []


            let filterEditions = editionsArray || []

            let currentEditionId
            if (defSaveObj?.masterPlanogram?.editionId) {
                currentEditionId = defSaveObj?.masterPlanogram?.editionId?.toString()
            } else if (defSaveObj?.editionId) {
                currentEditionId = defSaveObj?.editionId?.toString()
            }

            let removeCurrentEdition = filterEditions?.filter(
                (item) => item.id?.toString() !== currentEditionId
            ) || []

            const dataArray = {
                edition: removeCurrentEdition?.map((item) => ({
                    value: item.id || item.editionId,
                    label: item.editionName || item.name || item.edition_name || `Edition ${item.id}`,
                    departmentId: item.departmentId || item.department_id,
                    code: item.editionName || item.code || item.name,
                })),
            }
            setMultipleSelectOptions(dataArray)
        } else {
            setMultipleSelectOptions({
                edition: [],
            })
        }
    }, [data, depId, defSaveObj])

    const formValuesOnChangeDateFunc = (value, fieldName, dateFieldName) => {
        if (dateFieldName === 'actvationDate') {
            setAdavnceFilterFormVal((prevState) => ({
                ...prevState,
                actvationDate: {
                    ...prevState.actvationDate,
                    [fieldName]: value,
                },
            }))
        }
    }

    const formValuesOnChangeFunc = (value, fieldName) => {
        setAdavnceFilterFormVal((prevState) => ({
            ...prevState,
            [fieldName]: value,
        }))
    }

    const formValuesOnChangeInputNumberFunc = (value, fieldName, baseName) => {
        setAdavnceFilterFormVal((prevState) => ({
            ...prevState,
            [baseName]: {
                ...prevState[baseName],
                [fieldName]: value,
            },
        }))
    }

    return (
        <>
            <Col sm={12} md={12} lg={7}>
                <h6
                    dir={dir}
                    className={`ad-filter-sub-header ${dmode && 'head-dark'}`}
                >
                    {t('planogram')}
                </h6>
                <Row dir={dir}>
                    <Col sm={12} md={12} lg={6}>
                        <Row style={{ justifyContent: 'center' }}>
                            <Col className="">
                                <DatePickerComponent
                                    dmode={dmode}
                                    placeholder={t('FROM')}
                                    label={t('LAST_MODIFIED')}
                                    name="from"
                                    selectedDate={
                                        adavnceFilterFormVal?.actvationDate
                                            ?.from
                                    }
                                    setSelectedDate={(date, name) =>
                                        formValuesOnChangeDateFunc(
                                            date,
                                            name,
                                            'actvationDate'
                                        )
                                    }
                                    dir={dir}
                                />
                            </Col>
                            <MinusIconComp dmode={dmode} />
                            <Col className="">
                                <DatePickerComponent
                                    dmode={dmode}
                                    placeholder={t('TO')}
                                    name="to"
                                    selectedDate={
                                        adavnceFilterFormVal?.actvationDate?.to
                                    }
                                    setSelectedDate={(date, name) =>
                                        formValuesOnChangeDateFunc(
                                            date,
                                            name,
                                            'actvationDate'
                                        )
                                    }
                                    dir={dir}
                                />
                            </Col>
                        </Row>
                        <SelectComponent
                            dmode={dmode}
                            name="edition"
                            options={multipleSelectOptions?.edition}
                            label={t('EDITION')}
                            selectVal={adavnceFilterFormVal?.edition}
                            setSelectVal={(val, name) =>
                                formValuesOnChangeFunc(val, name)
                            }
                            dir={dir}
                            placeholder={t('SELECT_EDI')}
                        />
                    </Col>
                    <Col sm={12} md={12} lg={6}>
                        <Row className="mb-2">
                            <Col>
                                <InputNumberComponent
                                    dmode={dmode}
                                    value={
                                        adavnceFilterFormVal?.fieldsWidth?.from
                                    }
                                    initialValue={
                                        adavnceFilterFormVal?.fieldsWidth?.from
                                    }
                                    onValueChange={(value, name) =>
                                        formValuesOnChangeInputNumberFunc(
                                            value,
                                            name,
                                            'fieldsWidth'
                                        )
                                    }
                                    placeholder={t('FROM')}
                                    name="from"
                                    label={t('FIELDS_WIDTH')}
                                    dir={dir}
                                />
                            </Col>
                            <MinusIconComp dmode={dmode} />
                            <Col
                                style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                }}
                            >
                                <InputNumberComponent
                                    dmode={dmode}
                                    initialValue={
                                        adavnceFilterFormVal?.fieldsWidth?.to
                                    }
                                    value={
                                        adavnceFilterFormVal?.fieldsWidth?.to
                                    }
                                    onValueChange={(value, name) =>
                                        formValuesOnChangeInputNumberFunc(
                                            value,
                                            name,
                                            'fieldsWidth'
                                        )
                                    }
                                    placeholder={t('TO')}
                                    name="to"
                                    dir={dir}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </>
    )
}

export default FormColumnTwo
